// import React, {memo} from "react";
import { useState, useEffect, useRef } from "react";
import { useQueryClient, useMutation, useQuery } from '@tanstack/react-query';

import authAxios from "../../components/authAxios";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import NumberFormat from "react-number-format";
import { TextField, Autocomplete } from "@mui/material";
import {Button} from "@mui/material";

import DoneAllIcon from '@mui/icons-material/DoneAll';
import ClearIcon from '@mui/icons-material/Clear';

import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import { Modal, message } from 'antd';
import { faCheckCircle, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
// import { faCheckDouble } from "@fortawesome/free-solid-svg-icons/faCheckDouble";


// const LeaseEdit = ({lease}) => {

// const LeaseProducts = () => {
const LeaseProducts = ({ isModalOpen, setIsModalOpen, leaseProducts, setLeaseProducts }) => {

    const location = useLocation();
    const lease = location.state?.lease;

    // useCountRenders()
    const params = useParams()
    const queryClient = useQueryClient();

    const [error, setError] = useState('');

    const [txnLines, setTxnLines] = useState(() => {
        if (lease && lease.subscription_products) {
            return lease.subscription_products.map(product => ({
                sku: product.sku_id,
                sku_reference: product.sku_reference,
                name: product.product_name,
                quantity: product.quantity,
                price: product.price,
                subTotal: product.total,
                total: product.total
            }));
        }
        return [];
    });

    const [item, setItem] = useState();
    const [quantity, setQuantity] = useState();
    // const [amt, setAmt] = useState(0);
    const [subTotal, setSubTotal] = useState();
    const [sku, setSku] = useState();
    const [skuReference, setSkuReference] = useState();
    const [productName, setProductName] = useState();
    const [product, setProduct] = useState({
        sku:"",
        // skuReference:"",
        sku_reference:"",
        name:"",
        quantity:1, 
        price:0,
        // subTotal:0,
        sub_total:0,
        total:0
 
    });

    const amt = useRef(0)
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const [products, setProducts] = useState([]);
    const { data: items } = useQuery({
        queryKey: ['items'],
        queryFn: async () => {
            const response = await authAxios.get("/inventory/items");
            setProducts(response.data)
            return response.data;
        }
    });


    const [editingIndex, setEditingIndex] = useState(null);
    const [originalTotal, setOriginalTotal] = useState(null); // Store the original total

    
    const handleEditTotal = (index, newTotal) => {
        // console.log("IDX",index)
        // console.log("NEW TOTAL",newTotal)
        const updatedTxnLines = [...txnLines];
        updatedTxnLines[index].price = newTotal;
        updatedTxnLines[index].subTotal = newTotal;
        updatedTxnLines[index].total = newTotal;

        // console.log("UPDATED TXN LINES",updatedTxnLines)
        setTxnLines(updatedTxnLines);
    };
    const handleEditClick = (index, productTotal) => {
        if (editingIndex === index) {
            // If already editing, cancel the edit
            setEditingIndex(null);
        } else {
            // Set the editing index and store the original total
            setOriginalTotal(productTotal);
            setEditingIndex(index);
        }
    };

    const handleCancelEdit = () => {
        setEditingIndex(null);
    };


    const handleNewProduct = (e) => {
    
        const newProduct = {
            sku:product.sku,
            sku_reference:product.sku_reference,
            name:product.name,
            quantity:1, 
            price:amt.current,
            sub_total:amt.current,
            total:amt.current
        };

        // console.log("NEW PRODUCT",newProduct)

        setTxnLines([...txnLines, newProduct]);
        setLeaseProducts([...leaseProducts, newProduct]);  
        amt.current=0  
        setIsModalOpen(false); 
    }


    return(
        <>
        <div className="product-details-container">
            <table className="styled-table">

                <thead>
                    <tr >
                        <th>Reference</th>
                        <th>Product</th>
                        <th>Total</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>


                {txnLines && txnLines.map((product, index) => (
                        <tr key={index}>
                            <td>{product.sku_reference}</td>
                            <td>{product.name}</td>                              
                            <td>
                                {editingIndex === index ? (
                                    <NumberFormat
                                        value={product.total}
                                        onValueChange={(values) => {
                                            handleEditTotal(index, values.floatValue);
                                        }}
                                        thousandSeparator={true}
                                        // className="custom-input"
                                        customInput={TextField}
                                        variant="standard"
                                        inputProps={{ style: { textAlign: 'right' } }} // Align input text to the right
                                    />
                                ) 
                                : 
                                (
                                    Number(product.total).toLocaleString()
                                )
                            }
                            </td>
                            <td>
                                <IconButton 
                                    size="small"
                                    onClick={() => handleEditClick(index, product.total)}
                                    
                                >
                                    {editingIndex === index ? <DoneAllIcon className="edit-icon" /> : <FontAwesomeIcon icon={faPenToSquare} />}
                                </IconButton>
                                {editingIndex === index && (
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            const updatedTxnLines = [...txnLines];
                                            updatedTxnLines[index].total = originalTotal; 
                                            setTxnLines(updatedTxnLines);
                                            handleCancelEdit(); // Exit edit mode
                                        }}
                                    >
                                        <ClearIcon className="edit-icon" /> 
                                    </IconButton>
                                )}
                                
                            </td>
                        </tr>
                        ))}

                    </tbody>
            </table>
        </div>

        <div className="AddRow">
            <Button
                id="AddRowButton"
                onClick={() => {
                    setIsModalOpen(true)}
                }
                variant="outlined" 
                size="small"
                startIcon={<AddCircleOutlineIcon />}
            >
                Product
            </Button>
        </div>

        {isModalOpen && 
        <Modal className="dashboard-modal" title="Add Product" visible={isModalOpen} open={isModalOpen} onOk={handleNewProduct} onCancel={handleCancel}>
            <div className="dashboard-form">
                {/* <form onSubmit={handleSubmit}> */}
                <form>

                    <Autocomplete
                        onChange={(event, newValue) => {
                            setProductName(newValue.name)
                            setSkuReference(newValue.sku)
                            amt.current=newValue.price_data.price
                            setProduct({
                                sku:newValue.sku_id,
                                sku_reference:newValue.sku,
                                name:newValue.name,
                                price:newValue.price_data.price,
                                subTotal:newValue.price_data.price,
                                total:newValue.price_data.price
                            })
                        }}
                        options={products}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => 
                            <TextField 
                                className='custom-input'
                                label="Product" 
                                {...params} 
                            />
                        }
                    />

                    <NumberFormat 
                        value={amt.current>0?amt.current:""}
                        onChange={(e) => {
                            amt.current=parseFloat(e.target.value.replace(/,/g, ''))
                        }} 
                        className="custom-input"
                        fullWidth
                        label='Price'
                        variant="outlined" 
                        customInput={TextField}
                        thousandSeparator={true} 
                        required
                    />
                </form>
            </div>
        </Modal>
        }
        </>

    )

}

export default LeaseProducts;